import React from 'react';

export const CrossIcon = () => {
    return (
        <svg
            width="14"
            height="14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="m8.58 7 5.17-5.17a.48.48 0 0 0 0-.68l-.9-.9a.48.48 0 0 0-.68 0L7 5.43 1.83.25a.48.48 0 0 0-.68 0l-.9.9a.48.48 0 0 0 0 .68L5.43 7 .25 12.17a.48.48 0 0 0 0 .68l.9.9a.48.48 0 0 0 .68 0L7 8.58l5.17 5.17a.48.48 0 0 0 .68 0l.9-.9a.48.48 0 0 0 0-.68L8.58 7Z"
                fill="#140101"
            />
        </svg>
    );
};
